<template>
  <transition name="bounce">
    <div
      v-clicky
      v-if="show"
      class="toast show d-flex align-items-start gap-2"
      :class="`${toast.type}`"
      @click="closeToast"
      role="alert"
      aria-live="polite"
      :aria-label="`${toast.type} notification: ${toast.message}`"
    >
      <CircleCheckIcon
        v-if="toast.type === 'success'"
        style="width: 20px; height: 20px; flex-shrink: 0;"
      />
      <ErrorIcon
        v-else
        style="width: 20px; height: 20px; flex-shrink: 0"
      />
      <span v-html="safeMessage"></span>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import { toastHtml } from "../../../utilities/toastHtml";
import CircleCheckIcon from "../icons/CircleCheckIcon.vue";
import ErrorIcon from "../icons/ErrorIcon.vue";
export default {
  components: {
    CircleCheckIcon,
    ErrorIcon,
  },
  data() {
    return {
      show: false,
      timeoutId: null,
    };
  },
  computed: {
    ...mapGetters(["toast"]),
    safeMessage() {
      return toastHtml(this.toast.message);
    },
  },
  watch: {
    toast: {
      handler(newVal) {
        if (newVal.type) {
          setTimeout(() => {
            this.showToast();
          }, 500);
        }
      },
      deep: true,
    },
  },
  methods: {
    showToast() {
      this.show = true;
      this.timeoutId = setTimeout(() => {
        this.show = false;
      }, this.toast.duration || 10000);
    },
    closeToast() {
      clearTimeout(this.timeoutId);
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
.toast {
  position: fixed;
  top: 10%;
  right: 10%;
  z-index: 10000;
  width: 350px;
  padding: 10px;
  box-shadow: 0 0 10px var(--color-shadow-light);
  border-radius: 0;
  color: var(--color-text-primary);
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background-color: var(--color-bg-primary);
  &.success {
    border-top: 5px solid var(--color-success-alt);
    color: var(--color-success-alt);
  }
  &.error {
    border-top: 5px solid var(--color-error);
    color: var(--color-error);
  }
  span {
    color: var(--color-text-primary);
  }
}
</style>
